import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Referrals",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getReferrals, getReferralsError, getReferralsSuccess } =
  slice.actions;

reducerRegistry.register("referrals", reducer);
